module.exports = __webpack_public_path__ + "assets/ab18b23040a451cc04ab65de21254188.mp3";